<template>
  <div v-if="!isPrint">
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!-- 점검정보 -->
    <div>
      <h5 class="my-4"><i class="dot"></i>{{ $t('점검정보') }}</h5>
      <div class="writeGridContainer">
        <div>
          <div>{{ $t('점검일') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_1 }}</p>
          <date-selector v-else :readonly="board.readonly" v-model="form.inputA_1" />
        </div>
        <div>
          <div>{{ $t('소속명') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_2 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputA_2" />
        </div>
        <div>
          <div>{{ $t('점검자') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_3 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputA_3"/>
        </div>
      </div>
    </div>

    <table-inspect-merge
      :is-print="isPrint"
      :is-readonly="board.readonly"
      contentBefore="·"
      :title="form.inspectTitle"
      :table-header-title="form.inspectTableHeaderTitle"
      :table-header-note="[{ text: '비고', width: 320 }]"
      v-model="form.inspectList"
      class="mt-5"/>


    <!-- 결재란 -->
    <div class="mt-8">
      <div>
        <h5><i class="dot"></i>{{ $t('결재란') }}</h5>
      </div>
      <name-with-signature-row label-name="작성자" :name.sync="form.sign1.name" :signature.sync="form.sign1.sign" />
      <name-with-signature-row label-name="검토자" :name.sync="form.sign2.name" :signature.sync="form.sign2.sign" />
      <name-with-signature-row label-name="회람자" :name.sync="form.sign3.name" :signature.sync="form.sign3.sign" />
      <name-with-signature-row label-name="승인자" :name.sync="form.sign4.name" :signature.sync="form.sign4.sign" />
    </div>

    <!--    사진대지-->
    <photo-upload-grid-module
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
  <print v-else :board="board" :form="form"/>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspectMerge from "@/components/TableInspectMerge";
import DateSelector from "@/components/selector/DateSelector";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import CompanySelector from "@/components/selector/CompanySelector";

import inspectData from "./inspectData";
import SignField from "@/components/SignField.vue";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";
import Pagination from "@/components/Pagination.vue";
import Print from "./Print.vue";

export default {
  components: {
    Print,
    Pagination,
    NameWithSignatureRow,
    SignField,
    FieldSelectModule,
    FileUploadModule,
    TableInspectMerge,
    DateSelector,
    DisasterClassSelector,
    CompanySelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      form: {
        stdInfo: {},

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",

        inspectList: inspectData,
        inspectTitle: "프레스 안전 점검표",
        inspectTableHeaderTitle: "점검항목",

        photoList: [],
        fileList: [],

        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },
        sign3: {
          name: "",
          sign: "",
        },
        sign4: {
          name: "",
          sign: "",
        },
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  computed: {
  },
  methods: {
    getTranslateDisasterValue(value) {
      const prefix = "직접입력_";
      if (typeof value === "string" && value.startsWith(prefix)) {
        return value.substring(prefix.length);
      }
      return value;
    },
    applyDisasterValue(translatedValue) {
      const prefix = "직접입력_";
      const previous = this.form.stdInfo["재해형태"];
      if (typeof previous === "string" && previous.startsWith(prefix)) {
        if (typeof translatedValue === "string" && translatedValue.length > 0) {
          this.$set(this.form.stdInfo, "재해형태", `${prefix}${translatedValue}`);
        }
        return;
      }
      this.$set(this.form.stdInfo, "재해형태", translatedValue);
    },
    translationMap() {
      const prefix = "프레스안전점검표.프레스 안전 점검";
      const inspectList = Array.isArray(this.form.inspectList) ? this.form.inspectList : [];
      const photoList = Array.isArray(this.form.photoList) ? this.form.photoList : [];
      const fileList = Array.isArray(this.form.fileList) ? this.form.fileList : [];

      return {
        [`${prefix}.기본정보.회사명`]: this.form.stdInfo.field_name,
        [`${prefix}.기본정보.작성자이름`]: this.form.stdInfo.writer_name,
        [`${prefix}.기본정보.작성일`]: this.form.stdInfo.date,
        [`${prefix}.기본정보.점검일`]: this.form.stdInfo["점검일"],
        [`${prefix}.기본정보.점검장소`]: this.form.stdInfo["점검장소"],
        [`${prefix}.기본정보.재해형태`]: this.getTranslateDisasterValue(this.form.stdInfo["재해형태"]),
        [`${prefix}.기본정보.알림 대상자 선택`]: this.form.stdInfo["알림 대상자 선택"],
        [`${prefix}.점검정보.점검일`]: this.form.inputA_1,
        [`${prefix}.점검정보.소속명`]: this.form.inputA_2,
        [`${prefix}.점검정보.점검자`]: this.form.inputA_3,
        [`${prefix}.점검표`]: inspectList.map((item) => {
          const data = item || {};
          return {
            "점검항목": data.content,
            "비고": data["비고"],
          };
        }),
        [`${prefix}.결재란.작성자.이름`]: this.form.sign1.name,
        [`${prefix}.결재란.작성자.서명`]: this.form.sign1.sign,
        [`${prefix}.결재란.검토자.이름`]: this.form.sign2.name,
        [`${prefix}.결재란.검토자.서명`]: this.form.sign2.sign,
        [`${prefix}.결재란.회람자.이름`]: this.form.sign3.name,
        [`${prefix}.결재란.회람자.서명`]: this.form.sign3.sign,
        [`${prefix}.결재란.승인자.이름`]: this.form.sign4.name,
        [`${prefix}.결재란.승인자.서명`]: this.form.sign4.sign,
        [`${prefix}.사진대지`]: photoList.map((item) => {
          const data = item || {};
          return { "사진설명": data.input };
        }),
        [`${prefix}.파일첨부`]: fileList.map((item) => {
          const data = item || {};
          return {
            "파일명": data.fileName || data.name,
            "파일경로": data.url || data.path,
          };
        }),
      };
    },
    translate(translate) {
      const prefix = "프레스안전점검표.프레스 안전 점검";

      this.form.stdInfo.field_name = translate[`${prefix}.기본정보.회사명`];
      this.form.stdInfo.writer_name = translate[`${prefix}.기본정보.작성자이름`];
      this.form.stdInfo.date = translate[`${prefix}.기본정보.작성일`];
      this.$set(this.form.stdInfo, "점검일", translate[`${prefix}.기본정보.점검일`]);
      this.$set(this.form.stdInfo, "점검장소", translate[`${prefix}.기본정보.점검장소`]);
      this.applyDisasterValue(translate[`${prefix}.기본정보.재해형태`]);
      this.$set(this.form.stdInfo, "알림 대상자 선택", translate[`${prefix}.기본정보.알림 대상자 선택`]);

      this.form.inputA_1 = translate[`${prefix}.점검정보.점검일`];
      this.form.inputA_2 = translate[`${prefix}.점검정보.소속명`];
      this.form.inputA_3 = translate[`${prefix}.점검정보.점검자`];

      const inspectTranslations = translate[`${prefix}.점검표`];
      if (Array.isArray(inspectTranslations)) {
        const templateList = JSON.parse(JSON.stringify(inspectData));
        let currentList = [];
        if (this.form.inspectList && this.form.inspectList.length) {
          currentList = JSON.parse(JSON.stringify(this.form.inspectList));
        } else {
          currentList = JSON.parse(JSON.stringify(templateList));
        }
        const updatedList = inspectTranslations.map((item, index) => {
          let base = null;
          if (currentList[index]) {
            base = JSON.parse(JSON.stringify(currentList[index]));
          } else if (templateList[index]) {
            base = JSON.parse(JSON.stringify(templateList[index]));
          } else {
            base = { content: "", isChecked: "", 비고: "" };
          }
          if (typeof item["점검항목"] === "string") {
            base.content = item["점검항목"];
          }
          if (typeof item["비고"] === "string") {
            base["비고"] = item["비고"];
          }
          return base;
        });
        this.$set(this.form, "inspectList", updatedList);
      }

      this.$set(this.form.sign1, "name", translate[`${prefix}.결재란.작성자.이름`]);
      this.$set(this.form.sign1, "sign", translate[`${prefix}.결재란.작성자.서명`]);
      this.$set(this.form.sign2, "name", translate[`${prefix}.결재란.검토자.이름`]);
      this.$set(this.form.sign2, "sign", translate[`${prefix}.결재란.검토자.서명`]);
      this.$set(this.form.sign3, "name", translate[`${prefix}.결재란.회람자.이름`]);
      this.$set(this.form.sign3, "sign", translate[`${prefix}.결재란.회람자.서명`]);
      this.$set(this.form.sign4, "name", translate[`${prefix}.결재란.승인자.이름`]);
      this.$set(this.form.sign4, "sign", translate[`${prefix}.결재란.승인자.서명`]);

      const photoList = translate[`${prefix}.사진대지`];
      if (Array.isArray(photoList)) {
        const _photoList = JSON.parse(JSON.stringify(this.form.photoList && this.form.photoList.length ? this.form.photoList : []));
        for (let i = 0; i < photoList.length; i++) {
          if (!_photoList[i]) _photoList[i] = {};
          _photoList[i].input = photoList[i]["사진설명"];
        }
        this.$set(this.form, "photoList", _photoList);
      }

      const fileList = translate[`${prefix}.파일첨부`];
      if (Array.isArray(fileList)) {
        const _fileList = fileList.map((item) => ({
          fileName: item["파일명"],
          url: item["파일경로"],
        }));
        this.$set(this.form, "fileList", _fileList);
      }
    },
  },
};
</script>

